import React from 'react'
import { i18n } from '@fs/zion-locale'
import { useTranslation } from 'react-i18next'
import Head, { PageHead } from '@fs/zion-head'
import metaDataDefaults from './metaDataDefaults'
import getStructuredData from '../../../shared/components/PageHead/utils/structuredDataSchema'

export default function AboutPageHead() {
  const [t] = useTranslation()
  const title =
    metaDataDefaults[i18n.language]?.title ||
    t('about.meta.title', 'About Us | Our Mission, History, and Contact Information')
  const description =
    metaDataDefaults[i18n.language]?.description ||
    t(
      'about.meta.description',
      'FamilySearch provides free resources to help millions of people around the world discover their heritage and make family connections.'
    )
  const { metaData, linkedData } = metaDataDefaults[i18n.language] || metaDataDefaults.en
  const socialShareTitle = metaData.ogTitle
  const socialShareDescription = metaData.ogDescription
  const schemaDescription = linkedData?.description || description
  const homepageUrl = `https://www.familysearch.org/${i18n.language}/`
  const structuredData = getStructuredData(schemaDescription, homepageUrl, linkedData, i18n.language)

  const pageHeadProps = {
    title,
    description,
    socialShareTitle,
    socialShareDescription,
    image: { url: metaData.ogImage, width: 1200, height: 630 },
    omitSiteName: true,
  }

  return (
    <>
      <PageHead {...pageHeadProps} includeHreflang />
      <Head>
        <meta name="facebook-domain-verification" content="2zbl0fsfjt451p8ht8n2icpdf9m70p" />
        <meta property="og:image:type" content="image/jpeg" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Head>
    </>
  )
}
